"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValidProperty = isValidProperty;
/**
 * Checks if defined project property is not null or is not empty
 */ function isValidProperty(obj, property) {
    if (property in obj) {
        return obj[property] != null && obj[property] !== '';
    }
    return false;
}
